(function () {
  if (window.PoWishlist) return;
  var KEY = 'po:wishlist';

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
    updateCount();
  }

  function updateCount() {
    var n = read().length;
    document.querySelectorAll('[data-po-wishlist-count]').forEach(function (el) {
      el.textContent = n;
    });
    document.querySelectorAll('[data-po-wishlist-toggle]').forEach(function (btn) {
      var on = read().indexOf(btn.getAttribute('data-po-wishlist-toggle')) > -1;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  window.PoWishlist = {
    list: read,
    has: function (h) {
      return read().indexOf(h) > -1;
    },
    toggle: function (h) {
      var l = read();
      var i = l.indexOf(h);
      if (i > -1) {
        l.splice(i, 1);
      } else {
        l.push(h);
      }
      write(l);
      return i === -1;
    },
    remove: function (h) {
      var l = read();
      var i = l.indexOf(h);
      if (i > -1) {
        l.splice(i, 1);
        write(l);
      }
    },
  };

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-po-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    window.PoWishlist.toggle(btn.getAttribute('data-po-wishlist-toggle'));
  });

  function money(cents) {
    return new Intl.NumberFormat('en-GB', {style:'currency', currency:'GBP'}).format(cents / 100);
  }

  function imgUrl(src, w) {
    if (!src) return '';
    return src.split('?')[0] + '?width=' + w;
  }

  function renderPage() {
    var grid = document.querySelector('[data-po-wishlist-grid]');
    if (!grid) return;
    var empty = document.querySelector('[data-po-wishlist-empty]');
    var handles = read();
    grid.innerHTML = '';
    if (!handles.length) {
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    handles.forEach(function (h) {
      fetch('/products/' + h + '.js')
        .then(function (r) {
          if (!r.ok) throw new Error('gone');
          return r.json();
        })
        .then(function (p) {
          var card = document.createElement('div');
          card.className = 'po-wish-card';
          card.innerHTML =
            '<button type="button" class="po-wish-remove" aria-label="Remove from wishlist">&times;</button>' +
            '<a class="po-wish-media" href="' + p.url + '">' +
            (p.featured_image ? '<img src="' + imgUrl(p.featured_image, 480) + '" alt="" loading="lazy">' : '') +
            '</a>' +
            '<div class="po-wish-info">' +
            '<a class="po-wish-title" href="' + p.url + '">' + p.title + '</a>' +
            '<div class="po-wish-price">' + money(p.price) + '</div>' +
            '<a class="button po-wish-view" href="' + p.url + '">View Product</a>' +
            '</div>';
          card.querySelector('.po-wish-remove').addEventListener('click', function () {
            window.PoWishlist.remove(h);
            card.remove();
            if (!read().length && empty) empty.hidden = false;
          });
          grid.appendChild(card);
        })
        .catch(function () {
          window.PoWishlist.remove(h);
        });
    });
  }

  function init() {
    updateCount();
    renderPage();
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();

